import { sortBy, uniqBy } from 'lodash-es';

import { organizationsStore } from '@stores/dictionaryStores/organizationsStore';
import type { ReportSettingDto } from '@src/api';
import type { ReportSettingDtoDefId } from '@stores/dictionaryStores/reportSettings/reportSettingsStore';

type ReportSettingWithChildrenDtoDefId = ReportSettingDto & {
  children?: ReportSettingWithChildrenDtoDefId[];
  key: string;
  title: string;
};

// Группировка по report_group (1 уровень иерархии), по report_type (2 уровень иерархии)
export const toTreeView = (reportSettings: ReportSettingDtoDefId[]): ReportSettingWithChildrenDtoDefId[] => {
  const { organizations } = organizationsStore;

  const output = sortBy(
    reportSettings.filter((report) => report.reportGroupCode && report.reportTypeCode),
    ['organizationCode', 'reportGroupCode', 'reportTypeOrderNum', 'reportTypeCode'],
  );

  return uniqBy(output, 'organizationCode').map((org) => ({
    organizationCode: org.organizationCode,
    key: org.organizationCode ?? '',
    title: `${organizations?.find((el) => el.code === org.organizationCode)?.name ?? ''}`,
    children: uniqBy(
      output.filter((el) => el.organizationCode === org.organizationCode),
      'reportGroupCode',
    ).map((item) => ({
      organizationCode: item.organizationCode,
      reportGroupCode: item.reportGroupCode,
      key: `${item.organizationCode} - ${item.reportGroupCode}`,
      title: `${item.reportGroupCode ?? ''}${item.reportGroupCode && item.reportGroupName ? ' - ' : ''}${
        item.reportGroupName ?? ''
      }`,
      children: uniqBy(
        output.filter(
          (el) => el.reportGroupCode === item.reportGroupCode && el.organizationCode === item.organizationCode,
        ),
        'reportTypeCode',
      ).map((type) => ({
        ...type,
        reportGroupCode: type.reportGroupCode,
        reportTypeCode: type.reportTypeCode,
        key: `${type.organizationCode} - ${type.reportGroupCode} - ${type.reportTypeCode}`,
        title: `${type.reportTypeCode ?? ''}${type.reportTypeCode && type.reportTypeName ? ' - ' : ''}${
          type.reportTypeName ?? ''
        }`,
        count: reportSettings.filter(
          (report) =>
            report.organizationCode === type.organizationCode &&
            report.reportGroupCode === type.reportGroupCode &&
            report.reportTypeCode === type.reportTypeCode,
        ).length,
      })),
    })),
  }));
};
